module.exports = __webpack_public_path__ + "img/coach-2.2c959653.jpg";